import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom' //useNavigate

import { Sections } from './Sections'
import { Zones } from './Zones'
import { APP_VERSION } from './../../version'

import { DeleteGameToShow, ShowSectionsView } from './../../utilities/BL/Dashboard'
import { DeleteSessionData } from './../../utilities/BL/Sessions'
import { WaitUntilConnected, ConnectWebSocket, DisconnectWebSocket, IsWomensModeActive, GetAutozoneState as BLGetAutozoneState } from './../../utilities/BL/Zones'
import { Loading } from '../Commons/Loading'


const Dashboard = ({ roomId: propRoomId, defaultView }) => {
    const [view, setView] = useState('loading')
    const [searchParams] = useSearchParams()
    const roomId = searchParams.get('roomId') || propRoomId;
    const [connectionStatus, setConnectionStatus] = useState('idle') // 'idle', 'connecting', 'connected', 'reconnecting', 'error'
    const [toastMessage, setToastMessage] = useState('')

    const [isLoading, setIsLoading] = useState(true)


    const showToast = (msg) => {
        try {
            setToastMessage(msg)
            setTimeout(() => setToastMessage(''), 3000) // Se oculta tras 3 segundos    
        } catch (error) {
            
        }
    }

    // const SetViewToShow = async () => {
    //     try {
    //         // Obtén zona de parámetros de la URL
    //         const urlParameter = searchParams.get(process.env.REACT_APP_URLPARAMETER)

    //         const response = await ShowSectionsView(urlParameter)
            
    //         if (response.success) {
    //             await DeleteGameToShow()

    //             // Obtener la info completa de la zona
    //             const zone = response?.data
    //             if (!zone) {
    //                 await DeleteSessionData()
    //                 setView('zones')
    //             }

    //             // Obtener los datos de la zona
    //             const zoneName = zone?.text
    //             if (zoneName) {
    //                 // Cerrar sesión temporal
    //                 await DisconnectWebSocket()
                    
    //                 //Abrir conexión ideal
    //                 await ConnectWebSocket(zone.text, setConnectionStatus, showToast)
    //                 await WaitUntilConnected()
                    
    //                 setView('sections')
    //             } else {
    //                 await DeleteSessionData()
    //                 setView('zones')
    //             }
    //         } else {
    //             await DeleteSessionData()
    //             setView('zones')
    //         }
    //     } catch (error) {
    //         await DeleteSessionData()
    //         setView('zones')
    //     }
    // }

    const SetViewToShow = async () => {
        try {
            // 1) Consulta si autozona está activo
            const autoRes = await BLGetAutozoneState()
            const isAuto = autoRes?.success && !!autoRes?.data?.isAutozoneActive

            // 2) Si autozona: conectar directo SIN listado
            if (isAuto) {
                await DeleteGameToShow()       // como ya lo haces
                if (!roomId) {
                    await DisconnectWebSocket()    // aseguras limpio
                }

                // Conexión sin zona (el server asigna) + uid estable en la URL
                await ConnectWebSocket(null, setConnectionStatus, showToast, roomId)
                await WaitUntilConnected()

                // Tip: el server enviará {type:'assignedZone', data:{zone:'azul'|'oro'|...}}
                // y el BL guardará la zona en sesión vía SaveUserZone.
                setView('sections')
                return
            }

            // 3) Modo MANUAL (comportamiento actual)
            const urlParameter = searchParams.get(process.env.REACT_APP_URLPARAMETER)
            const response = await ShowSectionsView(urlParameter)

            if (response.success) {
                await DeleteGameToShow()

                const zone = response?.data
                if (!zone) {
                    await DeleteSessionData()
                    setView('zones')
                    return
                }

                const zoneName = zone?.text
                if (zoneName) {
                    if (!roomId) {
                        await DisconnectWebSocket()
                    }
                    await ConnectWebSocket(zone.text, setConnectionStatus, showToast, roomId)
                    await WaitUntilConnected()
                    setView('sections')
                } else {
                    await DeleteSessionData()
                    setView('zones')
                }
            } else {
                await DeleteSessionData()
                setView('zones')
            }
        } catch (error) {
            await DeleteSessionData()
            setView('zones')
        }
    }

    const Logout = async () => {
        try {
            setIsLoading(true)

            // 1. Liberar WakeLock de forma explícita
            try {
                if (window.activeWakeLock) {
                    await window.activeWakeLock.release()
                    window.activeWakeLock = null
                }
            } catch (wlErr) {
                console.warn("[Logout] Error al liberar WakeLock:", wlErr)
            }

            // 2. Limpiar el estado de zona en localStorage
            localStorage.removeItem('user_zone')

            // 3. Borrar la sesión local (cookies/sessionStorage/local)
            await DeleteSessionData()

            // 4. Invocar desconexión limpia de SignalR
            await DisconnectWebSocket()

            // 5. Redirigir al inicio de la aplicación conservando los query params (ej. roomId)
            const redirectUrl = window.location.pathname + window.location.search
            window.location.href = redirectUrl
        } catch (error) {
            console.error("[Logout] Error en proceso de cierre de sesión:", error)
            window.location.href = '/'
        } finally {
            setIsLoading(false)
        }
    }

    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")
            
            await SetViewToShow()
        } catch (error) {
            
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        LoadPage()
    }, [])

    useEffect(() => {
        return () => {
            if (!propRoomId && !searchParams.get('roomId')) {
                DisconnectWebSocket()
            }
        }
    }, [propRoomId])


    return (
        isLoading ? (
            <Loading />
        ) : (
            <>
                {/* Botón flotante persistente de cierre de sesión / inicio (z-index supremo) */}
                <button 
                    className="btn btn-outline-danger" 
                    onClick={Logout}
                    title="Cerrar Sesión / Inicio"
                    style={{
                        position: 'fixed',
                        top: '75px',
                        right: '15px',
                        zIndex: 999999,
                        width: '45px',
                        height: '45px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#ffffff',
                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.35)',
                        border: '1px solid #dc3545',
                        pointerEvents: 'auto'
                    }}
                >
                    <i className="bi bi-box-arrow-left" style={{ fontSize: '1.2rem' }}></i>
                </button>

                <main className="container Dashboard Container-FullHeight">
                    <div className="row mt-4">
                        {/* <img src="/img/brand/logotipo-adsl.png" className="LogoADSL" alt="Logo" /> */}
                        <img src="/img/page/xolos-five-bicolor.png" className="LogoADSLxZtudia" alt="Logo" />
    
                        <div className="mt-5">
                            {view === 'loading' && <p>Cargando...</p>}
                            {view === 'zones' && <Zones onZoneSaved={() => setView('sections')} roomId={roomId} />}
                            {view === 'sections' && <Sections onLogout={Logout} defaultView={defaultView} />}
                        </div>
                    </div>
                </main>
    
                <footer id='fdmFooter' className='container'>
                    {/* <p className='text-center FdmFooter FooterCredits'>Hecho con ♥ por Interaktia | 2026</p> */}
                    <p className='text-center FdmFooter FooterCredits'>
                        <a href='https://interaktia.com/?utm_source=dashboard_web&utm_medium=footer&utm_campaign=fdm_spinsmx_s2' target='_blank' className='text-dark'>Hecho con ♥ por Interaktia | 2026</a>
                    </p>
                    <p className='text-center text-muted small mt-1' style={{ fontSize: '9px', opacity: 0.5, margin: 0 }}>
                        v{APP_VERSION}
                    </p>
                </footer>
    
                {toastMessage && (
                    <div className="toast-container position-fixed bottom-0 start-50 translate-middle-x mb-3">
                        <div className="toast show bg-success text-white px-3 py-2 shadow rounded">
                            {toastMessage}
                        </div>
                    </div>
                )}
            </>
        )
    )
}

export { Dashboard };